import {Typography} from '@material-ui/core';
import React from 'react';
import './DropDownFieldValueStyles.scss';

// create a react functional component to render the field value with field label

// FIXME: props types and interface name
interface patientsTableProps {
  label?: string | any;
  value?: any;
  valueStyles?: any;
  dropDown?: any;
  onClickAction?: any;
}
const DropDownFieldValue = (props: patientsTableProps): React.ReactElement => {
  const {label, value, valueStyles, dropDown, onClickAction} = props;
  const handleClickAction = (): void => {
    if (typeof onClickAction === 'function') {
      onClickAction();
    }
  };
  return (
    <div className="field-value-wrapper">
      <Typography className="field-label">{label}</Typography>
      <Typography
        className={['field-value-text', valueStyles].join(' ')}
        data-test-id="pcl-appointments-patientNameInAppoinmentCard"
        onClick={() => handleClickAction()}>
        {value} {dropDown}
      </Typography>
    </div>
  );
};

export default DropDownFieldValue;
